// extracted by mini-css-extract-plugin
module.exports = {"clickable":"Icon_clickable__1IaOo","primary":"Icon_primary__2gdRq","danger":"Icon_danger__Pyc2N","success":"Icon_success__2q2Yp"};